module.exports = __webpack_public_path__ + "static/media/accident_per_month.42ca4376.png";